import { useEffect, useState } from 'react';
// mantine
import { Switch } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
// utils
import { TSessionsData } from '@newo/api/gateway';
import { FIELD_CHANGE_DEBOUNCE_DELAY } from '@/pages/Sessions/Sessions.utils.ts';

interface UniversalToggleProps {
    sessionId: string;
    isChecked: boolean;
    fieldName: keyof TSessionsData;
    onSave: (sessionId: string, data: TSessionsData) => void;
}

const UniversalToggle = ({
    sessionId,
    onSave,
    isChecked,
    fieldName
}: UniversalToggleProps) => {
    const [toggleValue, setToggleValue] = useState(isChecked);
    const [debounced] = useDebouncedValue(
        toggleValue,
        FIELD_CHANGE_DEBOUNCE_DELAY
    );

    useEffect(() => {
        if (isChecked !== debounced) {
            onSave(sessionId, {
                [fieldName]: debounced
            });
        }
    }, [debounced, isChecked, onSave, sessionId, fieldName]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setToggleValue(event.currentTarget.checked);
    };

    return <Switch defaultChecked={toggleValue} onChange={handleChange} />;
};

export default UniversalToggle;
